import React from 'react';
import Button from '../../composants/Button/Button';
import './ModificationModal.css';

interface ModificationModalProps {
  showModal: boolean;
  data: {
    nom: string;
    prenom: string;
    fonction: string;
    telephone: string;
    email: string;
  };
  onChange: (field: string, value: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  userRole: string | undefined;
  phoneError: string | null;
  setPhoneError: (error: string | null) => void;
  validatePhoneNumber: (phone: string, role: string) => boolean;
}

const ModificationModal: React.FC<ModificationModalProps> = ({
  showModal,
  data,
  onChange,
  onClose,
  onSubmit,
  userRole,
  phoneError,
  setPhoneError,
  validatePhoneNumber
}) => {
  if (!showModal) return null;

  const isAdmin = userRole === 'Acheteur signataire admin';

  return (
    <div className="modal-overlay">
      <div className="modal-content-modification">
        <h2>Demande de modification</h2>

        <div className="form-group">
          <label>Nom</label>
          <input
            type="text"
            value={data.nom}
            className="input-inactif"
            disabled
          />
        </div>

        <div className="form-group">
          <label>Prénom</label>
          <input
            type="text"
            value={data.prenom}
            className="input-inactif"
            disabled
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={data.email}
            onChange={e => onChange('email', e.target.value)}
            disabled={isAdmin}
            className={isAdmin ? "input-inactif" : ""}
          />
        </div>

        <div className="form-group">
          <label>Fonction</label>
          <input
            type="text"
            value={data.fonction}
            onChange={e => onChange('fonction', e.target.value)}
            // La fonction est toujours modifiable, même pour l'admin
          />
        </div>

        <div className="form-group">
          <label>Numéro de téléphone</label>
          <input
            type="text"
            value={data.telephone}
            onChange={e => {
              const newPhone = e.target.value;
              onChange('telephone', newPhone);

              if (newPhone.trim()) {
                if (!validatePhoneNumber(newPhone, userRole || '')) {
                  setPhoneError("Le numero doit etre un mobile francais valide (06 ou 07, 10 chiffres)");
                } else {
                  setPhoneError(null);
                }
              } else {
                setPhoneError(null);
              }
            }}
            // Le numéro de téléphone est toujours modifiable, même pour l'admin
            className={phoneError ? "input-error" : ""}
          />
          {phoneError && <p className="error-message">{phoneError}</p>}
        </div>

        <div className="modal-actions">
          <Button
            value="Annuler"
            variant="secondary"
            size="small"
            onClick={onClose}
          />
          <Button
            value="Envoyer"
            variant="primary"
            size="small"
            onClick={onSubmit}
            disabled={!!phoneError}
          />
        </div>
      </div>
    </div>
  );
};

export default ModificationModal;